import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import { TextField } from 'redux-form-material-ui';

import dottedNumberMask from '../../utils/masks/dottedNumberMask';

const DottedNumericRangeFilter = ({ name, title }) => (
  <FormControl>
    <FormLabel>{title}</FormLabel>
    <Field name={`${name}.minValue`} label="Mínimo" type="number" component={TextField} {...dottedNumberMask} />
    <Field name={`${name}.maxValue`} label="Máximo" type="number" component={TextField} {...dottedNumberMask} />
  </FormControl>
);

DottedNumericRangeFilter.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default DottedNumericRangeFilter;
